import BaseFactory from 'services/sports/default/base-factory';
import SimplexClassic from './simplex-classic';

class Factory extends BaseFactory {
    createObj(objectName, params) {
        return new SimplexClassic(params);
    }
}

export {Factory};
